import React from 'react';
import { useRecordContext, useTranslate } from 'react-admin';

import ChipField, { getChipColors } from '../../common/fields/ChipField';


const StatusField = ({ source = 'status', size = 'small', ...props }) => {
	const record = useRecordContext();
	const translate = useTranslate();

	if (!record) {
		return null;
	}

	const statuses = {
		'draft': translate('Draft'),
		'sent': translate('Sent'),
		'view': translate('View'),
		'paid': translate('Paid')
	};

	const status = record[source];
	let sx;
	switch (status) {
		case 'draft':
			sx = getChipColors('orange');
			break;
		case 'sent':
		case 'view':
			sx = getChipColors('blue');
			break;
		case 'paid':
			sx = getChipColors('green');
			break;
		default:
			break;
	}

	return (
		<ChipField source={status} record={statuses} sx={sx} size={size} {...props} />
	);
};

export default StatusField;
